/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const ContactsIconOutline = createIcon({
  displayName: 'ContactsIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        xmlns="http://www.w3.org/2000/svg"
        //         d="M1957 5086 c-47 -17 -95 -54 -179 -137 -371 -370 -478 -934 -263
        // -1387 67 -142 127 -224 267 -368 71 -72 128 -134 128 -137 0 -4 -375 -8 -832
        // -9 l-833 -3 -47 -23 c-60 -30 -120 -90 -150 -150 l-23 -47 0 -1015 c0 -973 1
        // -1016 19 -1050 38 -72 86 -119 154 -152 l67 -33 837 -3 837 -3 162 -212 c193
        // -253 209 -271 274 -305 41 -22 63 -27 125 -27 89 0 148 23 203 80 53 55 72
        // 101 114 290 l39 170 175 5 c173 6 177 6 241 38 76 37 120 83 157 162 l26 55 3
        // 368 c2 202 5 367 8 367 2 0 36 -16 75 -35 163 -82 347 -125 539 -125 246 0
        // 446 62 663 207 127 84 297 246 331 316 33 65 35 152 6 211 -13 27 -159 180
        // -422 442 -431 430 -427 426 -528 426 -92 0 -114 -14 -288 -186 l-162 -161
        // -510 510 -509 509 162 166 c172 174 187 197 187 285 0 97 3 93 -424 524 -430
        // 433 -453 451 -546 450 -25 0 -62 -6 -83 -13z m395 -653 l308 -308 -160 -160
        // c-96 -97 -165 -175 -175 -197 -21 -53 -19 -143 6 -198 15 -34 160 -185 617
        // -642 595 -594 597 -597 656 -613 66 -19 126 -15 179 11 17 9 103 86 190 172
        // l157 157 313 -313 312 -313 -55 -50 c-90 -83 -151 -126 -235 -168 -118 -59
        // -210 -82 -351 -88 -139 -6 -240 10 -366 58 -165 64 -176 74 -1006 903 -425
        // 424 -795 798 -822 832 -282 350 -257 851 58 1177 26 26 51 47 57 47 5 0 148
        // -138 317 -307z m341 -2151 l447 -447 -2 -470 -3 -470 -230 -5 c-245 -5 -254
        // -7 -298 -59 -24 -29 -29 -47 -97 -343 -12 -54 -26 -96 -30 -93 -4 3 -86 107
        // -181 231 -95 125 -187 235 -204 245 -29 18 -71 19 -892 19 l-863 0 0 920 0
        // 920 953 0 952 0 448 -448z"
        d="M732 2390 c-93 -57 -98 -206 -9 -265 41 -27 87 -36 128 -25 180 49
151 310 -35 310 -33 0 -62 -7 -84 -20z"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      />
      {/* <path
        d="M732 2390 c-93 -57 -98 -206 -9 -265 41 -27 87 -36 128 -25 180 49
151 310 -35 310 -33 0 -62 -7 -84 -20z"
      /> */}
    </>
  ),
})

const Contacts: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
    default:
      return <CustomIcon as={ContactsIconOutline} {...props} />
  }
}

export default memo(Contacts)
